import analysisApi from './analysis-api';

export default analysisApi;
